function syncFAQItemState(item: HTMLElement, active: boolean): void {
  item.classList.toggle('active', active);
  item.querySelector<HTMLElement>('.faq-question')
    ?.setAttribute('aria-expanded', String(active));
  item.querySelector<HTMLElement>('.faq-answer')
    ?.setAttribute('aria-hidden', String(!active));
}

/** Initialize a single-open FAQ accordion without stacking listeners on revisits. */
export function initFAQAccordion(screen: HTMLElement): void {
  const faqItems = screen.querySelectorAll<HTMLElement>('.faq-item');
  faqItems.forEach((item) => syncFAQItemState(item, item.classList.contains('active')));

  if (screen.dataset.faqInitialized === 'true') return;
  screen.dataset.faqInitialized = 'true';

  screen.querySelectorAll<HTMLElement>('.faq-question').forEach((question) => {
    question.addEventListener('click', () => {
      const faqItem = question.closest<HTMLElement>('.faq-item');
      const wasActive = faqItem?.classList.contains('active');

      faqItems.forEach((item) => syncFAQItemState(item, false));
      if (!wasActive && faqItem) syncFAQItemState(faqItem, true);
    });
  });
}
